<template >
  <div class="container-fluid" v-if="school && category">
    <div class="card">
      <h4>Хичээл: {{category.name}} <span v-if="category.typeDetail && category.typeDetail.name"> - {{category.typeDetail.name}}</span></h4>
      <h4>Сургууль: {{school.data().name}}</h4>
      <div class="card-body">
          <div class="card-header">
            <div>
                <p>
                Багшийн код Имэйл" форматаар оруулна уу!!!. Жишээ нь:  
                </p>
                <div class="form-group">
                <textarea
                    rows="10"
                    v-model.trim="inputText"
                    class="form-control"
                    placeholder="Багш нарын мэдээлэл"
                />
                </div>


                <hr />
            </div>
          </div>
          <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <button type="button" class="btn btn-primary" @click="addTimeTable">
                      Xуваарь уншиx
                    </button>
                  </div>
                  <div class="col">
                    <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="1" v-model= "lessonNameIsGiven" @click="_setLessonIsGLiven">
                    <label class="form-check-label" for="inlineCheckbox1">Xичээл өгөгдсөн</label>
                  </div>
                </div>
          </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header"> 
        <div class="row">
          <div class="col">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="1" v-model= "hideEmail" @click="_hideSelection(1,hideEmail)">
              <label class="form-check-label" for="inlineCheckbox1">Имэйл нууx</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="2" v-model= "hideLessonType" @click="_hideSelection(2,hideLessonType)">
              <label class="form-check-label" for="inlineCheckbox2">Төрөл нууx</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="inlineCheckbox3" value="3" v-model= "hideLessonByChoose" @click="_hideSelection(3,hideLessonByChoose)">
              <label class="form-check-label" for="inlineCheckbox3">Сонголт нууx</label>
            </div>
          </div>
          <div class="col">
            <div class="form-check form-check-inline">
              <div v-for="day in _getDays()" class="my-1 badge p-2 mr-2 week-badge" @click=_hideDays(day)>{{_getDayName(day)}}</div>
            </div>
          </div>
          <div class="col">
            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="1" v-model= "modeInGroup" @click="_setByGroup">
            <label class="form-check-label" for="inlineCheckbox1">Группээр ороxыг тоxируулаx {{modeInGroup}}</label>
          </div>
          <div class="col">
            <button class="btn btn-danger" @click="_clearData()">Арилгаx</button>
          </div>
          <div class="col">
          </div>
        </div>
      </div>
      <div class="card-body" style="overflow-x:auto;">
        <table class="table table-bordered">
            <tbody>
              <tr>
                <td rowspan="3" v-if="lessonNameIsGiven">Xичээл</td> 
                <td rowspan="3">N</td>
                <td rowspan="3" @click="_sortByName" class="text-primary" style="cursor:pointer; text-decoration: underline;">Нэр</td>
                <td rowspan="3" v-if="!hideEmail">Имэйл</td>
                <td rowspan="3">Анги/Групп</td>
                <td rowspan="3">......</td>
                <td rowspan="3" @click="_sortByTime" class="text-primary" style="cursor:pointer; text-decoration: underline;">Цаг</td>
                <td class="text-center" colspan="28" v-for="(row,i) in days">{{_getDayName(i+1)}}</td>
              </tr>
              <tr>
                <td class="text-center" colspan="14" v-for="(value,j) in cround">{{value}}</td></tr>

              <tr class="text-primary">
                <td colspan="2" class="text-center" v-for="(value,j) in cdays">{{value}}</td></tr>
              <tr v-for="(row,ind) in teachers">
                <td class="px-1 py-1" v-if="row['lesson']!=null&&lessonNameIsGiven">{{row['lesson']}}</td>
                <td class="px-1 py-1 text-center">{{ind+1}}.</td>
                <td class="px-1 py-1">{{row['bagsh']}}</td>
                <td v-if="row['teacherRef']!=undefined&&row['teacherRef']!=null && !hideEmail" class="bg-aqua px-1 py-1 schedule-cell text-primary" @click="_inputEmail(row)" style="cursor:pointer" >{{_getEmail(row['teacherRef'])}}</td>
                <td v-else class="bg-danger px-1 py-1 schedule-cell text-primary" @click="_inputEmail(row)" style="cursor:pointer" >{{_getEmail(row['teacherRef'])}}</td>
                
                
                <td v-if="row['byClass']==thisIsClass" class="px-1 py-1 isClass" style="cursor:pointer" @click="_setZaavalLessonGroupOrClassForAll(row)">ангиар {{row['byClass']}},{{thisIsClass}}</td>
                <td v-else-if="row['byClass']==thisIsZaavalLessonGroup" class="px-1 py-1 isZaavalLessonGroup" style="cursor:pointer" @click="_setZaavalLessonGroupOrClassForAll(row)">группээр {{row['byClass']}},{{thisIsClass}}</td>
                <td v-else class="px-1 py-1 isZaavalLessonGroup" @click="_setZaavalLessonGroupOrClassForAll(row)" style="cursor:pointer">Xolimog {{row['byClass']}},{{thisIsClass}}</td>

                <td class="px-1 py-1"> <div class="my-1 badge p-2 mr-2 badge-danger" style="cursor:pointer; font-size:11pt" @click="_createLesson(row)">үүсгэx</div></td>
                <td class="px-1 py-1">{{row['totalTime']}}</td>
                <td v-for="(cell,j) in row['values']" class="p-0 m-0 text-center schedule-cell" 
                  v-bind:style="cell['last']==true?'border-right: 2px solid red':'border-right: 1px solid #e3e6f0'" @click="_clickOnCell(cell, ind)">
                  
                    <span v-if="cell['roomnumber']==true" class="text-primary" style="font-size:9pt; font-weight:normal;vertical-align: text-top;">{{cell['value']}}</span>
                    <span v-else style="font-size:12pt; color:black;font-weight:bold;">
                    <!-- <span v-bind:style="cell['value']!=null?'background-color:yellow':'red'">{{cell['value']}}</span> -->

                    <span v-if="cell['byClass']==thisIsClass" >{{cell['value']}}</span>
                    <span v-else-if="cell['byClass']==thisIsSongonLessonGroup" v-bind:style="'background-color:yellow;'" title="Группээр ороx xичээл">{{cell['value']}}</span>
                    <span v-else-if="cell['byClass']==thisIsZaavalLessonGroup" class="isZaavalLessonGroup" title="Группээр ороx xичээл">{{cell['value']}}</span>
                    <span v-else>{{cell['index']}}</span>  
                    </span>
                  </td> 
              </tr>
            </tbody>

        </table>
      </div>
    </div>
    <div class="modal fade" id="chooseProgram" tabindex="-1" role="dialog" aria-labelledby="chooseProgramLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="proModalLabel">Засаx</h5>
   
              <!-- <p>{{programYear.name}} - <span v-if="programYear.startDay">{{programYear.startDay.year}}</span></p> -->
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="row" v-if="userProfile && userProfile.role && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
                  <div class="col-6" v-if="school!=null">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Анги</label>
                      <select class="form-control" v-model="department" >
                        <option v-for="(dep, index) in departments" v-bind:key="dep.id" v-bind:value="dep">{{dep.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Бүлэг</label>
                      <select class="form-control" v-model="selectedProgram" >
                        <option v-for="(prog, index) in programs" v-bind:key="prog.id" v-bind:value="prog">{{prog.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label for="exampleFormControlSelect1">Xичээлийн төрөл</label>
                        <div class="form-check">
                          <input v-model="byClass" class="form-check-input" type="radio" v-bind:value="true">
                          <label class="form-check-label" for="exampleRadios1">
                            Заавал судлаx
                          </label>
                        </div>
                        <div class="form-check">
                          <input v-model="byClass" class="form-check-input" type="radio"v-bind:value="false">
                          <label class="form-check-label" for="exampleRadios2">
                            Сонгон судлаx
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <label for="exampleFormControlSelect1">Aнги/группээр орох:</label>
                        <div class="form-check">
                          <input v-model="byClass" class="form-check-input" type="radio" v-bind:value="true">
                          <label class="form-check-label" for="exampleRadios1">
                            Ангиар ороx
                          </label>
                        </div>
                        <div class="form-check">
                          <input v-model="byClass" class="form-check-input" type="radio"v-bind:value="false">
                          <label class="form-check-label" for="exampleRadios2">
                            Группээр ороx
                          </label>
                        </div>
                      </div>
                    </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="_saveCell" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
            </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="inputEmail" tabindex="-1" role="dialog" aria-labelledby="chooseProgramLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="proModalLabel">Багшийн имэйлийг оруулаx</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="form-group">
                  <label for="exampleInputEmail1">Имэйл оруулаx</label>
                  <small id="emailHelp" class="form-text text-muted">Багшийн имэйлийг сонгоно уу.</small>
                  <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
                </div>
                <div class="form-group" v-if="teachers && teachers.length>0">
                  <label for="exampleInputEmail1">Багшийин имэйл сонгоx</label>
                  <small id="emailHelp" class="form-text text-muted">Багшийн имэйлийг сонгоно уу.</small>
                  <select class="form-control" v-model="selectedTeacherEmail" >
                    <option v-for="(teacher, index) in registeredTeachers" v-bind:value="teacher">{{index+1}}. {{teacher.name}} - {{teacher.code}} - {{teacher.email}}</option>
                  </select>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="_saveEmail(selectedTeacherEmail)" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "AllLessonTimeTable",
  data() {
    return {
      generateResults: [],
      lessonNameIsGiven:false,
      sortedByDownUp : false,
      sortedByNameDownUp: true,
      modeInGroup: true,
      selectedTeacherEmail: null,
      selectedTeacher: null,
      registeredTeachers:[],
      hideEmail:false,
      hideLessonByChoose: false,
      hideLessonType: false,

      thisIsNothing:0,
      thisIsClass:1,
      thisIsSongonLessonGroup:2,
      thisIsZaavalLessonGroup:3,

      selectedCellIndex:null,
      byClass: false,
      school:null,
      department:null,
      departments:[],
      selectedProgram:null,
      programs:[{id:'A', name:'A'}, {id:'Б', name:'Б'}, {id:'В', name:'В'}],
      
      inputText:null,
      teachers: [],
      limitWeekTime:98,
      limitTime:7,
      maxTime:7,

      days:7,
      round:2,
      daytime:7,
      data:null,
      cround: [],
      cdays: [],
      category:null
    };
  },
  methods: {
      randomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      _getClassGroupRef(classGroupName){
        //for example 6A
        for(var j=0; j< this.departments.length; j++){
          var cleanedString = classGroupName.replace(/[^0-9]/g, '');
 
          if(this.departments[j]['index'],this.departments[j]['index']== cleanedString) 
            return this.departments[j].ref;
      
          // if(classGroupName.indexOf(this.departments[j]['index'])>0) {
          //   console.log('>>>> ', classGroupName, this.departments[j]['index']);
          //   return true
          // };
        }
        return null;
      },
      async _createLesson(teacher){
        if(this.category && this.category.ref){
          this.loading=true;
          // var songohmh=fb.db.doc("schools/"+this.schoolId+"/categories/4Zkt5SfZ7wj3HQWb1eRt");
          // var zaavalmh=fb.db.doc("schools/"+this.schoolId+"/categories/Q1bXcsgCQ6mP6PdKNksX");
          var songohmh=null;
          var zaavalmh=null;
          if(this.category.type && this.category.type.id=='songoh'){
            songohmh=this.category.ref;
            if(this.category.option)
              zaavalmh=this.category.option;
          }
          else{
            zaavalmh=this.category.ref;
            if(this.category.option)
              songohmh=this.category.option;
          }

          var numberOfClass = 0;
          var numberOfTask = 0;

          for(var i=0; i<teacher['values'].length; i++){
            var cell = teacher['values'][i];
      
            if(!cell['roomnumber'] && cell['value'].length>0){
              numberOfTask ++;
              var foundDepartmentRef = this._getClassGroupRef(cell['value'])
              
              if(foundDepartmentRef!=null) {
                var day=this.randomInteger(1, 5); //day
                var line=this.randomInteger(1, 2); //eelj
                var time=this.randomInteger(1, 7); //tsag TODOX
                console.log(numberOfTask + '.'+cell['value']+" _ "+cell.byClass);
                numberOfClass++;
                // foundDepartmentRef.collection("programs").where("name", "==", )
                // console.log(cell);
                // console.log(foundDepartmentRef);
                // console.log(teacher);
                // console.log("_____________");
                //TODO
                var batch =fb.db.batch();
                var lessonRef=fb.db.collection("schools/"+this.schoolId+"/lessons").doc();
                console.log("BYCLASS - "+ cell.byClass);
                
                if(cell.byClass!=0 && cell.byClass==2){
                  this.generateResults.push(cell);
                  var categoryDoc=await songohmh.get();
                  var lessonName=categoryDoc.data().name;
                  //songoh hicheel
                  var checkLesson=await fb.db.collection("schools/"+this.schoolId+"/lessons").where("teacher", "==", teacher.teacherRef.ref).where("category", "==", songohmh).where("isGroup", "==",true).where("departments", "array-contains", foundDepartmentRef).limit(1).get();
                  if(checkLesson && !checkLesson.empty){
                    //teacher lesson exists
                    console.log("LESSON ALREADY CREATED");
                    
                    var lessonDoc=checkLesson.docs[0];
                    if(lessonDoc && lessonDoc.data().lessonGroupRefs && lessonDoc.data().lessonGroupRefs.length>0){
                      await this.createGroupSchedule(lessonDoc.ref, day, line, time, lessonDoc.data().lessonGroupRefs[0], teacher.teacherRef.ref, batch);
                    }
                    alert(cell.classIndex+" анги "+ teacher.teacherRef.name+" багш дээр сонгох хичээл аль хэдийн үүссэн байна.");
                    
                    continue;
                    // return;
                  }
                  else{
                    console.log("LESSON NOT CREATED");
                    // teacher lesson not exists
                    var lessonGroupRef=fb.db.collection("schools").doc(this.schoolId).collection("lessonGroups").doc();
                    var tmpGroup={};
                    // tmpGroup.program=programData;
                    tmpGroup.createdAt=new Date();
                    tmpGroup.name=lessonName+" - "+teacher.teacherRef.name+" / Сонгох -"+(cell.classIndex)+" анги/";
                    tmpGroup.department=foundDepartmentRef;
                    if(teacher.teacherRef)
                      tmpGroup.teacher=teacher.teacherRef.ref;
                    if(lessonRef)
                      tmpGroup.lesson=lessonRef;
                    batch.set(
                      lessonGroupRef,
                      tmpGroup
                    );
                    var lessonItem={ 
                      createdAt: new Date(), 
                      name: lessonName, 
                      classNos: [parseInt(cell.classIndex)], 
                      departments:[foundDepartmentRef],
                      isGroup:true, 
                      lectureCode: new Date().getTime(),  
                      sector:null,
                      teacher: teacher.teacherRef.ref,
                      teacherFirstName: teacher.teacherRef.name,
                      teacherLastName: teacher.teacherRef.lastName,
                      teacherRefs:[teacher.teacherRef.ref],
                      teachers:[
                        {
                          description:"Bagsh",
                          firstName:teacher.teacherRef.name,
                          lastName: teacher.teacherRef.lastName,
                          reference: teacher.teacherRef.ref
                        }
                      ],
                      user: fb.db.collection("users").doc(this.currentUser.uid),
                      userId:this.currentUser.uid
                    };
                    lessonItem.category=songohmh;
                    lessonItem.lessonGroups=[];
                    lessonItem.lessonGroupRefs=[];
                    lessonItem.lessonGroupIds=[];
                    lessonItem.lessonGroups.push( {
                      school:fb.db.collection("schools").doc(this.schoolId),
                      group: lessonGroupRef,
                      groupName: tmpGroup.name
                    });

                    lessonItem.lessonGroupRefs.push(lessonGroupRef);
                    lessonItem.lessonGroupIds.push(lessonGroupRef);


                    await this.createGroupSchedule(lessonRef, day, line, time, lessonGroupRef, teacher.teacherRef.ref, batch);

                    batch.set(
                      lessonRef,
                      lessonItem
                    );
                  }

                }
                else if(cell.byClass!=0 && cell.byClass==1){
                  
                  this.generateResults.push(cell);
                  var categoryDoc=await zaavalmh.get();
                  var lessonName=categoryDoc.data().name;
                  // .toUpperCase()
                  var proSnapshot=await foundDepartmentRef.collection("programs").where("name", "==", cell.classProgram).limit(1).get();
                  if(proSnapshot && !proSnapshot.empty){
                    //zaaval uzeh angiar oroh hicheel
                    var programData=proSnapshot.docs[0];
                    var checkLesson=await fb.db.collection("schools/"+this.schoolId+"/lessons").where("isGroup", "==", false).where("teacher", "==", teacher.teacherRef.ref).where("category", "==", zaavalmh).where("departments", "array-contains", foundDepartmentRef).limit(1).get();
                    if(checkLesson && !checkLesson.empty){
                      //teacher lesson exists
                      console.log("LESSON CREATED")
                      var lessonDoc=checkLesson.docs[0];
                      if(lessonDoc && lessonDoc.exists && lessonDoc.data()){
                        if(!lessonDoc.data().groups){
                          console.log("11");
                          batch.update(
                            lessonDoc.ref,
                            {
                              groups:[
                                {
                                  school: fb.db.collection("schools").doc(this.schoolId),
                                  department: foundDepartmentRef,
                                  program: programData.ref,
                                  departmentName: cell.classIndex,
                                  programName: programData.data().name
                                }
                              ],
                              programs: [programData.ref],
                              programIds: [programData.id]
                            }
                          );
                        }
                        else{
                          console.log("2");
                          var found=false;
                          for(const programRef of lessonDoc.data().programs){
                            if(programRef.path==programData.ref.path){
                              found=true;
                              break;
                            }
                          }
                          console.log(found);
                          if(found==false){
                            batch.update(
                              lessonDoc.ref,
                              {
                                groups:
                                fb.firestore.FieldValue.arrayUnion(
                                  {
                                    school: fb.db.collection("schools").doc(this.schoolId),
                                    department: foundDepartmentRef,
                                    program: programData.ref,
                                    departmentName: cell.classIndex,
                                    programName: programData.data().name
                                  }
                                ),
                                programs: fb.firestore.FieldValue.arrayUnion(programData.ref),
                                programIds: fb.firestore.FieldValue.arrayUnion(programData.id)
                              }
                            );
                          }
                          else{
                            alert(cell.value+" анги "+ teacher.teacherRef.name+" багш дээр хичээл үүссэн байна.");
                          }
                        }

                        await this.createClassSchedule(lessonDoc.ref, day, line, time, programData.ref, teacher.teacherRef.ref, batch);
                      }
                    }
                    else{
                      //teacher lesson not exists
                      console.log("LESSON NOT CREATED")
                        
                        var lessonItem={ 
                          createdAt: new Date(), 
                          name: lessonName, 
                          classNos: [parseInt(cell.classIndex)], 
                          departments:[foundDepartmentRef],
                          isGroup:false, 
                          lectureCode: new Date().getTime(),  
                          sector:null,
                          teacher: teacher.teacherRef.ref,
                          teacherFirstName: teacher.teacherRef.name,
                          teacherLastName: teacher.teacherRef.lastName,
                          teacherRefs:[teacher.teacherRef.ref],
                          teachers:[
                            {
                              description:"Bagsh",
                              firstName:teacher.teacherRef.name,
                              lastName: teacher.teacherRef.lastName,
                              reference: teacher.teacherRef.ref
                            }
                          ],
                          user: fb.db.collection("users").doc(this.currentUser.uid),
                          userId:this.currentUser.uid
                        };
                        lessonItem.category=zaavalmh;
                        lessonItem.groups=[];
                        lessonItem.programs=[];
                        lessonItem.programIds=[];
                        lessonItem.groups.push({
                          school: fb.db.collection("schools").doc(this.schoolId),
                          department: foundDepartmentRef,
                          program: programData.ref,
                          departmentName: cell.classIndex,
                          programName: programData.data().name
                        });
                        lessonItem.programs.push(programData.ref);
                        lessonItem.programIds.push(programData.id);

                        batch.set(
                          lessonRef,
                          lessonItem
                        );

                        await this.createClassSchedule(lessonRef, day, line, time, programData.ref, teacher.teacherRef.ref, batch);
                      
                    }
                  }
                }
                else if(cell.byClass!=0 && cell.byClass==3){
                  this.generateResults.push(cell);

                  //zaaval uzeh grouper oroh hicheel
                  var categoryDoc=await songohmh.get();
                  var lessonName=categoryDoc.data().name;
                  var proSnapshot=await foundDepartmentRef.collection("programs").where("name", "==", cell.classProgram.toUpperCase()).limit(1).get();
                  if(proSnapshot && !proSnapshot.empty){
                    var programData=proSnapshot.docs[0];
                    var checkLesson=await fb.db.collection("schools/"+this.schoolId+"/lessons").where("teacher", "==", teacher.teacherRef.ref).where("isGroup", "==", true).where("category", "==", zaavalmh).where("departments", "array-contains", foundDepartmentRef).limit(1).get();
                    if(checkLesson && !checkLesson.empty){
                      //teacher lesson exists
                      console.log("LESSON ALREADY CREATED");
                      // alert(cell.classIndex+" анги "+ teacher.teacherRef.name+" багш дээр сонгох хичээл аль хэдийн үүссэн байна.");
                      var lessonDoc=checkLesson.docs[0];
                      if(lessonDoc && lessonDoc.exists && lessonDoc.data()){
                        if(!lessonDoc.data().lessonGroups){
                          var lessonGroupRef=fb.db.collection("schools").doc(this.schoolId).collection("lessonGroups").doc();
                          var tmpGroup={};
                          // tmpGroup.program=programData;
                          tmpGroup.createdAt=new Date();
                          tmpGroup.name=lessonName+" - "+teacher.teacherRef.name+" / "+(cell.value)+" /";
                          tmpGroup.programRef=programData.ref;
                          if(teacher.teacherRef)
                            tmpGroup.teacher=teacher.teacherRef.ref;

                          tmpGroup.lesson=lessonDoc.ref;
                          batch.set(
                            lessonGroupRef,
                            tmpGroup
                          );
                          console.log("11");
                          batch.update(
                            lessonDoc.ref,
                            {
                              groups:[
                                {
                                  school: fb.db.collection("schools").doc(this.schoolId),
                                  department: foundDepartmentRef,
                                  program: programData.ref,
                                  departmentName: cell.classIndex,
                                  programName: programData.data().name
                                }
                              ],
                              programs: [programData.ref],
                              programIds: [programData.id],
                              lessonGroups: [{
                                school:fb.db.collection("schools").doc(this.schoolId),
                                group: lessonGroupRef,
                                groupName: tmpGroup.name
                              }],
                              lessonGroupRefs:[lessonGroupRef],
                              lessonGroupIds:[lessonGroupRef.id]
                            }
                          );
                          await this.createGroupSchedule(lessonDoc.ref, day, line, time, lessonGroupRef, teacher.teacherRef.ref, batch);
                        }
                        else{
                          console.log("2");
                          var foundGroups=await fb.db.collection("schools").doc(this.schoolId).collection("lessonGroups").where("programRef", "==", programData.ref).where("lesson", "==", lessonDoc.ref).get();
                          if(foundGroups && !foundGroups.empty){
                            var found=false;
                            var foundDoc=null;
                            for(const groupDoc of foundGroups.docs){
                              if(groupDoc && groupDoc.data().programRef &&  groupDoc.data().programRef.path==programData.ref.path){
                                found=true;
                                foundDoc=groupDoc;
                                break;
                              }
                            }
                            console.log(found);
                            if(found==false){
                              var lessonGroupRef=fb.db.collection("schools").doc(this.schoolId).collection("lessonGroups").doc();
                              var tmpGroup={};
                              // tmpGroup.program=programData;
                              tmpGroup.createdAt=new Date();
                              tmpGroup.name=lessonName+" - "+teacher.teacherRef.name+" / "+(cell.value)+" /";
                              tmpGroup.programRef=programData.ref;
                              if(teacher.teacherRef)
                                tmpGroup.teacher=teacher.teacherRef.ref;
                              tmpGroup.lesson=lessonDoc.ref;
                              batch.set(
                                lessonGroupRef,
                                tmpGroup
                              );
                              batch.update(
                                lessonDoc.ref,
                                {
                                  groups:
                                  fb.firestore.FieldValue.arrayUnion(
                                    {
                                      school: fb.db.collection("schools").doc(this.schoolId),
                                      department: foundDepartmentRef,
                                      program: programData.ref,
                                      departmentName: cell.classIndex,
                                      programName: programData.data().name
                                    }
                                  ),
                                  programs: fb.firestore.FieldValue.arrayUnion(programData.ref),
                                  programIds: fb.firestore.FieldValue.arrayUnion(programData.id),
                                  lessonGroups: fb.firestore.FieldValue.arrayUnion({
                                    school:fb.db.collection("schools").doc(this.schoolId),
                                    group: lessonGroupRef,
                                    groupName: tmpGroup.name
                                  }),
                                  lessonGroupRefs:fb.firestore.FieldValue.arrayUnion(lessonGroupRef),
                                  lessonGroupIds: fb.firestore.FieldValue.arrayUnion(lessonGroupRef.id)
                                }
                              );
                              await this.createGroupSchedule(lessonDoc.ref, day, line, time , lessonGroupRef, teacher.teacherRef.ref, batch);
                            }
                            else{
                              batch.update(
                                lessonDoc.ref,
                                {
                                  groups:
                                  fb.firestore.FieldValue.arrayUnion(
                                    {
                                      school: fb.db.collection("schools").doc(this.schoolId),
                                      department: foundDepartmentRef,
                                      program: programData.ref,
                                      departmentName: cell.classIndex,
                                      programName: programData.data().name
                                    }
                                  ),
                                  programs: fb.firestore.FieldValue.arrayUnion(programData.ref),
                                  programIds: fb.firestore.FieldValue.arrayUnion(programData.id),
                                  lessonGroups: fb.firestore.FieldValue.arrayUnion({
                                    school:fb.db.collection("schools").doc(this.schoolId),
                                    group: foundDoc.ref,
                                    groupName: foundDoc.data().name
                                  }),
                                  lessonGroupRefs:fb.firestore.FieldValue.arrayUnion(foundDoc.ref),
                                  lessonGroupIds:fb.firestore.FieldValue.arrayUnion(foundDoc.ref.id)
                                }
                              );
                              await this.createGroupSchedule(lessonDoc.ref, day, line, time, foundDoc.ref, teacher.teacherRef.ref, batch);
                            }
                          }
                          else{
                            var lessonGroupRef=fb.db.collection("schools").doc(this.schoolId).collection("lessonGroups").doc();
                            var tmpGroup={};
                            // tmpGroup.program=programData;
                            tmpGroup.createdAt=new Date();
                            tmpGroup.name=lessonName+" - "+teacher.teacherRef.name+" / "+(cell.value)+" /";
                            tmpGroup.programRef=programData.ref;
                            if(teacher.teacherRef)
                              tmpGroup.teacher=teacher.teacherRef.ref;
                            tmpGroup.lesson=lessonDoc.ref;
                            batch.set(
                              lessonGroupRef,
                              tmpGroup
                            );
                            console.log("11");
                            batch.update(
                              lessonDoc.ref,
                              {
                                groups:fb.firestore.FieldValue.arrayUnion({
                                    school: fb.db.collection("schools").doc(this.schoolId),
                                    department: foundDepartmentRef,
                                    program: programData.ref,
                                    departmentName: cell.classIndex,
                                    programName: programData.data().name
                                  }),
                                programs: fb.firestore.FieldValue.arrayUnion(programData.ref),
                                programIds: fb.firestore.FieldValue.arrayUnion(programData.id),
                                lessonGroups: fb.firestore.FieldValue.arrayUnion({
                                  school:fb.db.collection("schools").doc(this.schoolId),
                                  group: lessonGroupRef,
                                  groupName: tmpGroup.name
                                }),
                                lessonGroupRefs:fb.firestore.FieldValue.arrayUnion(lessonGroupRef),
                                lessonGroupIds:fb.firestore.FieldValue.arrayUnion(lessonGroupRef.id)
                              }
                            );
                            await this.createGroupSchedule(lessonDoc.ref, day, line, time, lessonGroupRef, teacher.teacherRef.ref, batch);
                          }
                        }
                      }
                    }
                    else{
                      console.log("LESSON NOT CREATED");
                      // teacher lesson not exists
                      var lessonGroupRef=fb.db.collection("schools").doc(this.schoolId).collection("lessonGroups").doc();
                      var tmpGroup={};
                      // tmpGroup.program=programData;
                      tmpGroup.createdAt=new Date();
                      tmpGroup.name=lessonName+" - "+teacher.teacherRef.name+" / "+(cell.value)+" /";
                      tmpGroup.programRef=programData.ref;
                      if(teacher.teacherRef)
                        tmpGroup.teacher=teacher.teacherRef.ref;
                      if(lessonRef)
                        tmpGroup.lesson=lessonRef;
                      batch.set(
                        lessonGroupRef,
                        tmpGroup
                      );
                      var lessonItem={ 
                        createdAt: new Date(), 
                        name: lessonName, 
                        classNos: [parseInt(cell.classIndex)], 
                        departments:[foundDepartmentRef],
                        isGroup:true, 
                        lectureCode: new Date().getTime(),  
                        sector:null,
                        teacher: teacher.teacherRef.ref,
                        teacherFirstName: teacher.teacherRef.name,
                        teacherLastName: teacher.teacherRef.lastName,
                        teacherRefs:[teacher.teacherRef.ref],
                        teachers:[
                          {
                            description:"Bagsh",
                            firstName:teacher.teacherRef.name,
                            lastName: teacher.teacherRef.lastName,
                            reference: teacher.teacherRef.ref
                          }
                        ],
                        user: fb.db.collection("users").doc(this.currentUser.uid),
                        userId:this.currentUser.uid
                      };
                      lessonItem.category=zaavalmh;
                      lessonItem.lessonGroups=[];
                      lessonItem.lessonGroupRefs=[];
                      lessonItem.lessonGroupIds=[];
                      lessonItem.lessonGroups.push( {
                        school:fb.db.collection("schools").doc(this.schoolId),
                        group: lessonGroupRef,
                        groupName: tmpGroup.name
                      });

                      lessonItem.lessonGroupRefs.push(lessonGroupRef);
                      lessonItem.lessonGroupIds.push(lessonGroupRef.id);

                      lessonItem.groups=[];
                      lessonItem.programs=[];
                      lessonItem.programIds=[];
                      lessonItem.groups.push({
                        school: fb.db.collection("schools").doc(this.schoolId),
                        department: foundDepartmentRef,
                        program: programData.ref,
                        departmentName: cell.classIndex,
                        programName: programData.data().name
                      });
                      lessonItem.programs.push(programData.ref);
                      lessonItem.programIds.push(programData.id);

                      batch.set(
                        lessonRef,
                        lessonItem
                      );

                      await this.createGroupSchedule(lessonRef, day, line, time, lessonGroupRef, teacher.teacherRef.ref, batch);
                    }
                  }
                }
                await batch.commit();
                if(numberOfClass==teacher.totalTime) break;
              }
                
  
              // for(var j=0; j< this.departments.length; j++){
              //   //  console.log(this.departments[j].index, cell['value'],'found....', this.departments[j].ref.path);
              //    if(cell['value'].startsWith(this.departments[j].index)){
              //       console.log(cell['value'],'founddd....', this.departments[j].ref.path);
              //       continue;
              //    }
              // }
            }
            console.log('-------------');
          }
          // the code above is waiting.....
          this.loading=false;
          this._showResults();
 
        }
      },
      _getValueFromList(list, value){
        for(var i=0; i<list.length; i++){
          if(list[i]['classIndex']==value) return i;
        }
        return -1;
      },
      _showResults(){
        console.log('--*****');
        var endResults=[];
        for(var i=0; i<this.generateResults.length; i++){

          var el = this.generateResults[i];
          console.log('>' + this.generateResults[i]['classIndex']);
          //endResults.update({'class':this.generateResults[i]['classIndex']});
          var foundIndex = this._getValueFromList(endResults,this.generateResults[i]['classIndex']);
         
          
          if(foundIndex>-1) {
             var foundElement = endResults[foundIndex];
             foundElement['groups'].push(this.generateResults[i]['classProgram']);
            
          }else {
            endResults.push({'classIndex': this.generateResults[i]['classIndex'], 'groups':[this.generateResults[i]['classProgram'],], 'zaavalgroup': true});
          }

        }
        console.log('---------------> ' + endResults.length);
        var numberOfGroups = 0;
        for(var i=0; i<endResults.length; i++){
          numberOfGroups = numberOfGroups + endResults[i]['groups'].length;
          console.log(endResults[i]);

        }
        console.log('number of class generated: ' + endResults.length);
        console.log('number of groups generated: ' + numberOfGroups);

      },
      _findTeachersRef(name){
        var foundTeachers=[];
        var cuttedName = name.indexOf('.')>0?name.substring(name.indexOf('.')+1):name;
        var cuttedLastName = name.indexOf('.')>0?name.substring(0,name.indexOf('.')):null;
        console.log(cuttedLastName);
        for(var i=0; i< this.registeredTeachers.length; i++){
          var teacher = this.registeredTeachers[i];
          //console.log(teacher.lastName.toLowerCase().startsWith(cuttedLastName));
          if(teacher!=null&&teacher.name!=null&&teacher.name.toLowerCase()==cuttedName.toLowerCase()){
              foundTeachers.push({'name':cuttedName, 'email': teacher.email,'ref':teacher.ref, 'lastName': cuttedLastName, 'found':cuttedLastName!=null&&teacher.lastName!=null&&teacher.lastName.toLowerCase().startsWith(cuttedLastName.toLowerCase())});
          }
            
        }
        return foundTeachers;
      },
      _sortedArrayByName: function(arrays, max) {
        function compare1(a, b) {
          if (a.bagsh.localeCompare(b.bagsh))
           return -1;
          if (!a.bagsh.localeCompare(b.bagsh))
             return 1;
           
          return 0;
        }
        function compare2(a, b) {
          if (!a.bagsh.localeCompare(b.bagsh))
           return -1;
          if (a.bagsh.localeCompare(b.bagsh))
             return 1;
           
          return 0;
        }

        return max?arrays.sort(compare1):arrays.sort(compare2);
      },
      _sortedArrayByTime: function(arrays, max) {
        function compare1(a, b) {
          if (a.totalTime < b.totalTime)
           return -1;
          if (a.totalTime > b.totalTime)
             return 1;
           
          return 0;
        }
        function compare2(a, b) {
          if (a.totalTime > b.totalTime)
           return -1;
          if (a.totalTime < b.totalTime)
             return 1;
           
          return 0;
        }

        return max?arrays.sort(compare1):arrays.sort(compare2);
      },
      _sortByTime(){
         this.teachers=this._sortedArrayByTime(this.teachers, this.sortedByDownUp);
         this.sortedByDownUp=!this.sortedByDownUp;
      },
      _sortByName(){
          console.log(this.sortedByNameDownUp);
         this.teachers=this._sortedArrayByName(this.teachers, this.sortedByNameDownUp);
         this.sortedByNameDownUp=!this.sortedByNameDownUp;
      },
      _getTotalTime(row){
        var k = 0;
        for(var i=0; i<row['values'].length; i++){
          var cell = row['values'][i];
          if(!cell['roomnumber'] && cell['value'].length>0){
            k++;
          }
        }
        return k;
      },
      _clearData(){
        this.teachers=[];
        //this.inputText = null;
      },
      _getDays(){
        return [1,2,3,4,5,6,7];
      },  
   
      _setZaavalLessonGroupOrClassForAll(row){
       for(var i=0; i<row['values'].length; i++){
         var cell = row['values'][i];
         if(!cell['roomnumber']){
           //console.log(cell['index'], cell['value'], cell['value'].length, cell['roomnumber'], cell['byClass']);
           if(row['byClass']==this.thisIsClass) {

             if(cell['byClass']!=this.thisIsSongonLessonGroup)
              cell['byClass']=this.thisIsZaavalLessonGroup;

           }
           else if(row['byClass']==this.thisIsZaavalLessonGroup){
              
                cell['byClass']=this.thisIsClass;
           } 
           //else if(cell['byClass']==2) cell['byClass']=1;
         }
         //console.log(row['values'][i]['value'], row['values'][i]['value'].length);
          //TODO bugdiig bulgeer bolgood daraa n' neg negeer angi buzaad bolgovol groupeer gedeg nb uurchlogdoh heregtei baina.
        }
            
        if(row['byClass']==this.thisIsClass)  
          row['byClass']=this.thisIsZaavalLessonGroup;

        else if(row['byClass']==this.thisIsZaavalLessonGroup) 
          row['byClass'] = this.thisIsClass;
      },
      _setByGroup(){
        this.modeInGroup = !this.modeInGroup;
      },
      _setLessonIsGLiven(){
        this.lessonNameIsGiven = !this.lessonNameIsGiven;
      },
      _getEmail(teacherRef){
        if(teacherRef!=undefined&&teacherRef!=null) return teacherRef.email;
        else return ('.....');
      },
      _inputEmail(row){
        console.log(row['bagsh']);
        this.selectedTeacher = row;
        $('#inputEmail').modal('toggle');
      },
      _hideDays(day){
        console.log(day);
      },
      _hideSelection(selectionType, selection){
        console.log(selectionType, selection);
      },
      _getDayName(dayIndex){
        if(dayIndex==1) return 'Даваа';
        else if(dayIndex==2) return 'Мягмар';
        else if(dayIndex==3) return 'Лxагва';
        else if(dayIndex==4) return 'Пүрэв';
        else if(dayIndex==5) return 'Баасан';
        else if(dayIndex==6) return 'Бямба';
        else if(dayIndex==7) return 'Ням';
        else return dayIndex;
      },
      _isInt(n) {
        return n % 1 === 0;
      },
      _isEven(value) {
        if (value%2 == 0)
          return true;
        else
          return false;
      },
      _isClass(data){
        var anguud = Array.from('абвгдеё');
        for(var indx in anguud){
          if(data.includes(anguud[indx])) return true;
        }
        return false;
      },
      _getClassProgram(data){
        var anguud = Array.from('абвгдеё');
        for(var indx in anguud){
          if(data.includes(anguud[indx])) {
            return anguud[indx];
          }
        }
        return -1;
      },
      addTimeTable(){

        var limit = 2 * this.round * this.days * this.daytime;

        if(this.inputText!=null && this.inputText!=''){
            //TODO
            var arrayOfLines = this.inputText.match(/[^\r\n]+/g);
            var i = 0;
            arrayOfLines.forEach(value=>{

            var lineArray=value.split('\t');
            console.log(++i + '.' +lineArray.length);

            var row=[];
            var subindex =0;
            var startIndex = 1;
            if(this.lessonNameIsGiven)
              startIndex = 2;
            for(var i=startIndex;i<limit;i++){

              var cellValue= lineArray[i];
              if(cellValue==undefined) 
                cellValue = "";

              if(subindex==14) subindex=0;
              else subindex++;

              if(i>14&&this._isInt((i)/14)) 
                row.push({'value':cellValue, 'index':i, 'last': true, 'roomnumber': this._isEven(i), 'subindex':subindex, 'byClass': this._setClassOrGroup(cellValue), 'classIndex':cellValue.replace(/[^0-9]/g, ''),'classProgram':this._getClassProgram(cellValue)});
              else if(i==14) 
                row.push({'value':cellValue, 'index':i, 'last': true, 'roomnumber': this._isEven(i), 'subindex':subindex, 'byClass': this._setClassOrGroup(cellValue), 'classIndex':cellValue.replace(/[^0-9]/g, ''),'classProgram':this._getClassProgram(cellValue)});
              else 
              row.push({'value':cellValue, 'index':i, 'last': false, 'roomnumber': this._isEven(i), 'subindex':subindex, 'byClass': this._setClassOrGroup(cellValue), 'classIndex':cellValue.replace(/[^0-9]/g, ''),'classProgram':this._getClassProgram(cellValue)});
            }
            var tmpTeacher;
            if(this.lessonNameIsGiven) 
              tmpTeacher = {lesson:lineArray[0],bagsh:lineArray[1], values:row, 'email':null, 'byClass': this.thisIsClass,};
            else 
              tmpTeacher = {bagsh:lineArray[0], values:row, 'email':null, 'byClass':this.thisIsClass};
            tmpTeacher['totalTime']=this._getTotalTime(tmpTeacher);


            var similarTeachersFound = lineArray[0]!=null&&lineArray[0]!=''?this._findTeachersRef(lineArray[0]):[];
            if(similarTeachersFound.length>0)
              tmpTeacher['teacherRef'] = similarTeachersFound[0];
            

            this.teachers.push(tmpTeacher);
            // console.log('--------------------');
            // var bagsh = {'bagsh':lineArray[0], 'times':[], 'length':lineArray.length ,'numberOfClass':0};
            // var angi;
            // var numberOfClass=0;
            // var ix =0;
            // var eelj=0;
            // for(var i=1; i<lineArray.length; i++){
            //   angi = {'angi':lineArray[i], 'tsag': ix, 'value':i,}; 
            //   bagsh.times.push(angi);
            // }
            // bagsh['numberOfClass']=numberOfClass;
            // this.teachers.push(bagsh);

            });
            this.inputText=''
        }
    },
    _setClassOrGroup(cellValue){
      if(cellValue!=null&&cellValue!='') {
        return this._isClass(cellValue)?this.thisIsClass:this.thisIsSongonLessonGroup;
      } else return this.thisIsNothing;
    },
    _clickOnCell(cell, ind){
      this.selectedCellIndex = ind;
       
       if(this.modeInGroup) {
         cell['byClass'] == this.thisIsSongonLessonGroup? cell['byClass'] =this.thisIsClass:cell['byClass'] =this.thisIsSongonLessonGroup;
       }
       else $('#chooseProgram').modal('toggle');

    },
    _saveCell(cell){
      console.log(this.selectedProgram.name, this.department.name, this.byClass, this.selectedCellIndex);
      console.log(cell);
    },
    _saveEmail(selectedTeacherEmail){
      this.selectedTeacher['email']=selectedTeacherEmail['email'];
    },
    async readSchool(){
      var schoolData=await fb.db.collection("schools").doc(this.schoolId).get();
      if(schoolData.exists){
        schoolData.departments=[];
        this.school=schoolData;
        if(this.lessonId && this.lessonId!=''){
          schoolData.ref.collection("categories").doc(this.lessonId).get().then(cDoc=>{
            if(cDoc && cDoc.exists){
              let object=cDoc.data();
              object.id=cDoc.id;
              object.ref=cDoc.ref;
              this.category=object;
            }
          });
        }

        fb.db.collection("schools/"+this.schoolId+ "/departments").orderBy("index")
        .get().then(querySnapshot=> {
            querySnapshot.forEach(data=> {
              let object=data.data();
              object.ref=data.ref;
              object.id=data.id;
              this.departments.push(object);
            });
        
        });
      }
    },
    async createClassSchedule(lessonRef, day, line, time, programRef, teacherRef, batch){
      var checkSchedule=await lessonRef.collection("lessonschedule").where("program", "==", programRef).where("day", "==", day).where("line", "==", line).where("time", "==", time).get();
      if(checkSchedule && !checkSchedule.empty){
        console.log("SCHEDULE exists");
      }
      else{
        batch.set(
          lessonRef.collection("lessonschedule").doc(),
          {
            createdAt: new Date(),
            day: day,
            line:line,
            time:time,
            group:null,
            isGroup:false,
            lesson :lessonRef,
            program: programRef,
            school: fb.db.collection("schools").doc(this.schoolId),
            teacher: teacherRef,
            user: fb.db.collection("users").doc(this.currentUser.uid)
          }
        );
      }

    },
    async createGroupSchedule(lessonRef, day, line, time, groupRef, teacherRef,batch){
      var checkSchedule=await lessonRef.collection("lessonschedule").where("group", "==", groupRef).where("day", "==", day).where("line", "==", line).where("time", "==", time).get();
      if(checkSchedule && !checkSchedule.empty){
        console.log("GROUP SCHEDULE exists");
      }
      else{
        batch.set(
          lessonRef.collection("lessonschedule").doc(),
          {
            createdAt: new Date(),
            day: day,
            line:line,
            time:time,
            group:groupRef,
            isGroup:true,
            lesson :lessonRef,
            program: null,
            school: fb.db.collection("schools").doc(this.schoolId),
            teacher: teacherRef,
            user: fb.db.collection("users").doc(this.currentUser.uid)
          }
        );
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
  },
  created() {
    this.generateResults=[];
    var _this = this;
    if (this.schoolId != null && this.schoolId != "") this.readSchool();
 
    for(var i=0; i<this.days;i++){
      this.cround.push(1);
      this.cround.push(2);
    }
    var lim = 7*2
    for(var i=0; i<lim;i++){
      for(var j=0; j<this.daytime;j++)
        this.cdays.push(j+1);
    }

    fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name").get().then(querySnapshot=>{
      querySnapshot.forEach(data=> {
        let object=data.data();
        object.ref=data.ref;
        object.id=data.id;
        this.registeredTeachers.push(object);
      });
    });
 
    // fb.db.collection("schools/"+this.schoolId+"/departments").orderBy("index").get().then(querySnapshot=>{
    //   querySnapshot.forEach(data=> {
    //     let object=data.data();
    //     object.ref=data.ref;
    //     object.id=data.id;
    //     this.departments.push(object);
    //   });
    // });
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    },
  },
};
</script>

<style scoped>
  .schedule-cell:hover {
    /* background-color:#f0f6ff; */
    background-color: #fff3cd;
    cursor: pointer;
  }
  .bygroup-cell{
    /* background-color:#f0f6ff; */
    background-color: #000;
    color:white;
    cursor: pointer;
  }
.verticaltext{
    width:1px;
    word-wrap: break-word;
    font-family: monospace; /* this is just for good looks */
}
</style>